
<template>
  <div class="teamWarp" v-if="isMobile!=0">
    <div class="pc pw100" v-if="isMobile==1">
      <header-view ref="headers"></header-view>
      <div class="page page-4" :style="'padding-bottom:'+footerHeight+'px;padding-top:'+headerHeight+'px'">
        <div class="page4Warp">
          <div class="title fAb">Team</div>
          <div class="tDetail">
            <div class="tDetailLeft">
              <img :src="teamInfo.avatar" alt="">
            </div>
            <div class="tDetailRight">
              <div class="userInfo">
                <div class="name fOH">
                  {{ teamInfo.nickname }}
                </div>
                <div class="desc fOR">
                  {{ teamInfo.zw_name }}
                </div>
              </div>
              <div class="experience fOb" v-html="teamInfo.desc">
              </div>
              <div class="backInfo" @click="goBack">
                <img src="../../assets/image/team-bak.png" alt="">
                <div class="text fOR">Back</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile pw100" v-else>
      <TeamMobileView @goBack="goBack"></TeamMobileView>
    </div>
  </div>
</template>
<script>

import headerView from "@/components/Common/Header.vue";
import TeamView from "@/components/Team/index.vue";
import TeamMobileView from "@/components/Mobile/teamDetail.vue";

export default {
  components: {TeamMobileView, TeamView, headerView},
  data(){
    return {
      headerHeight: 104,
      footerHeight: 20,
      tList:[
      ]
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    teamInfo(){
      return this.$store.getters.teamInfo
    }
  },
  created() {
    this.$store.dispatch('setPageCurrentIndex',3)
  },
  mounted() {
    if(Object.keys(this.teamInfo).length === 0){
      this.getDetail(this.$route.query.id)
    }
  },
  methods:{
    async getDetail(id){
      let {data} = await this.$api.getData('team/detail/' + id,{})
      await this.$store.dispatch('setStoreByKeyData',{key:'setTeamInfo',data:data})
    },
    goBack(){
      this.$store.dispatch('setStoreByKeyData',{key:'setFGoHome',data:3})
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">
.pc{
  .page-4{
    height: 100%;
    background-image: url("../../assets/image/page4_bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .page4Warp{
      height: 100%;
      width: 60%;
      box-sizing: border-box;
      padding: 2rem 0 0;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      overflow: hidden;
      .tDetail{
        box-sizing: border-box;
        width: 100%;
        max-height: 65vh;
        padding: 2rem 2rem 4rem;
        background: linear-gradient(-20deg, rgba(24, 95, 203, .7) 0%, rgba(116, 181, 212, .7) 100%);
        border-radius: 10px;
        display: flex;
        align-items: flex-start;
        position: relative;
        .backInfo{
          position: absolute;
          z-index: 100;
          left: 2rem;
          bottom: 2rem;
          font-size: 1rem;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img{
            width: 1rem;
            margin-right: .5rem;
          }
        }
        .tDetailRight{
          flex: 2;
          height: 100%;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          margin-left: 2rem;
          //overflow: hidden;
          .userInfo{
            border-bottom: .12rem solid #fff;
            padding-bottom: 1rem;
            color: #fff;
            .name{
              font-size: 1.8rem;
            }
            .desc{
              margin-top: .3rem;
              font-size: 1rem;
            }
          }
          .experience{
            overflow: hidden;
            overflow-y: auto;
            flex: 1;
            padding: 1rem 0;
            color: #fff;
            font-size: .95rem;
            line-height: 1.8rem;
          }
        }
        .tDetailLeft{
          flex: 1.2;
          img{
            width: 100%;
            padding-bottom: 2rem;
          }
        }
      }
      .title{
        text-align: center;
        padding-bottom: 2rem;
        color: #fff;
        font-size: 1.8rem;
      }
    }
  }
}
</style>
